import DashboardService from "../../redux/services/dashboard";
import {
  FETCH_DASHBOARD_HEADERS_REQUEST,
  FETCH_DASHBOARD_HEADERS_SUCCESS,
  FETCH_DASHBOARD_TABLE_FAILURE,
  FETCH_DASHBOARD_TABLE_REQUEST,
  FETCH_DASHBOARD_TABLE_SUCCESS,
} from "./types";

export const getAdminHeadersInfo = (param) => async (dispatch) => {
  try {
    dispatch({
      type: FETCH_DASHBOARD_HEADERS_REQUEST,
    });
    const res = await DashboardService.getAdminHeadersInfo(param);

    dispatch({
      type: FETCH_DASHBOARD_HEADERS_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    console.log(err);
  }
};

export const getAdminTableInfo = (param) => async (dispatch) => {
  try {
    dispatch({
      type: FETCH_DASHBOARD_TABLE_REQUEST,
    });
    const res = await DashboardService.getAdminTableInfo(param);

    dispatch({
      type: FETCH_DASHBOARD_TABLE_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: FETCH_DASHBOARD_TABLE_FAILURE,
      payload: [],
    });
    console.log(err);
  }
};
